module.exports = __webpack_public_path__ + "static/media/carbon_blog.2f841741.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/carbon_blog.svg
// module id = 233
// module chunks = 1